import React from 'react';
import {StatusSelectValueProps} from '../../Filters/StatusSelect';
import {SelectedBooleanStatusType} from '../../Filters/utils';
import StatusSelectMonitoring from "./StatusSelectMonitoring";

// TODO: сделать общими с подсказками в иконках
const ENABLED_MODE_STATUS = {
    true: 'Источник включен',
    false: 'Источник выключен',
    unknown: 'Состояние: Неизвестно',
};

export function EnableModeStatusSelectMonitoring(props: StatusSelectValueProps<SelectedBooleanStatusType>) {
    return (
        <StatusSelectMonitoring
            {...props}
            statusDescription={ENABLED_MODE_STATUS}
            allValuesLabel="Все состояния"
        />
    );
}
export default EnableModeStatusSelectMonitoring;
